import { Helmet } from 'react-helmet-async';

const DEFAULT_META = {
  title: 'Jon Quintano Fotografía | Fotógrafo Profesional en Burgos',
  description: 'Fotógrafo profesional especializado en bodas, eventos, retratos y fotografía comercial en Burgos. Capturando momentos únicos con pasión y creatividad.',
  image: 'https://res.cloudinary.com/demo/image/upload/v1/jon-quintano/og-image.jpg',
  url: 'https://jonquintano.com',
  type: 'website',
  siteName: 'Jon Quintano Fotografía',
  locale: 'es_ES',
  twitterHandle: '@jonquintano'
};

export const SEO = ({ 
  title, 
  description, 
  image, 
  url,
  type = 'website',
  keywords,
  article = null,
  noIndex = false
}) => {
  const seo = {
    title: title ? `${title} | Jon Quintano Fotografía` : DEFAULT_META.title,
    description: description || DEFAULT_META.description,
    image: image || DEFAULT_META.image,
    url: url || DEFAULT_META.url,
    type: type
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={seo.url} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Robots */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={seo.type} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:site_name" content={DEFAULT_META.siteName} />
      <meta property="og:locale" content={DEFAULT_META.locale} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      
      {/* Article specific (for blog posts) */}
      {article && (
        <>
          <meta property="article:published_time" content={article.publishedTime} />
          <meta property="article:author" content={article.author || 'Jon Quintano'} />
          {article.category && <meta property="article:section" content={article.category} />}
          {article.tags && article.tags.map((tag, i) => (
            <meta key={i} property="article:tag" content={tag} />
          ))}
        </>
      )}
      
      {/* Additional SEO */}
      <meta name="author" content="Jon Quintano" />
      <meta name="geo.region" content="ES-BU" />
      <meta name="geo.placename" content="Burgos" />
      <meta name="geo.position" content="42.3514;-3.6754" />
      <meta name="ICBM" content="42.3514, -3.6754" />
    </Helmet>
  );
};

export default SEO;
